import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import { UiLegacy } from "@silvertours/front-legacy-shared";
import { LayoutLegacy } from "@silvertours/front-legacy-entities";
import { PrimaryTitle, SupplierList, SupplierListItem, SupplierWrapper } from "./Suppliers.styles";
import { TrustSeals } from "../TrustSeals";
var Suppliers = function(param) {
    var title = param.title, suppliers = param.suppliers, _includeSearch = param.includeSearch, includeSearch = _includeSearch === void 0 ? true : _includeSearch;
    if (!title && (!suppliers || suppliers.length === 0)) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(LayoutLegacy.FilledSegment, {
        id: "suppliers",
        children: [
            /*#__PURE__*/ _jsx(TrustSeals, {}),
            /*#__PURE__*/ _jsxs(SupplierWrapper, {
                includeSearch: includeSearch,
                children: [
                    title && /*#__PURE__*/ _jsx(PrimaryTitle, {
                        children: title
                    }),
                    suppliers && includeSearch && /*#__PURE__*/ _jsx(SupplierList, {
                        isStandAlone: !title,
                        children: suppliers.map(function(param) {
                            var id = param.id;
                            return /*#__PURE__*/ _jsx(SupplierListItem, {
                                children: /*#__PURE__*/ _jsx(UiLegacy.ImageSVG, {
                                    name: id
                                })
                            }, id);
                        })
                    })
                ]
            })
        ]
    });
};
export { Suppliers };
